// hooks/useSupportedLocations.js
import { useEffect, useState } from "react";

export default function useSupportedLocations() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchLocations() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/locations/v1/locations/supported`
        );
        const json = await res.json();
        if (json.success && Array.isArray(json.data)) {
          setLocations(json.data);
        }
      } catch (err) {
        console.error("Failed to load supported locations", err);
      } finally {
        setLoading(false);
      }
    }
    fetchLocations();
  }, []);

  return { locations, loading };
}
